import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, ShieldCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { PinPad } from "@/components/common/PinPad";

// Première connexion avec un PIN provisoire : l'employé choisit son PIN personnel (jamais visible par la direction).
export default function SetOwnPin({ user, pinLen = 4, onDone }) {
  const [step, setStep] = useState(1);
  const [first, setFirst] = useState("");
  const [second, setSecond] = useState("");
  const [busy, setBusy] = useState(false);
  const value = step === 1 ? first : second;
  const setValue = step === 1 ? setFirst : setSecond;
  const next = async () => {
    if (step === 1) { if (first.length !== pinLen) return; setStep(2); return; }
    if (second.length !== pinLen) return;
    if (first !== second) { toast.error("Les deux PIN ne correspondent pas"); setSecond(""); setFirst(""); setStep(1); return; }
    setBusy(true);
    try { await api.setOwnPin(first, second); toast.success("PIN personnel enregistré"); onDone(); }
    catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Erreur"); setSecond(""); setFirst(""); setStep(1); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="set-own-pin" className="min-h-screen bg-[#0C1713] text-stone-100 grid place-items-center px-5">
      <div className="w-full max-w-sm rounded-3xl bg-[#111F1A] border border-[#1B3028] p-6 text-center space-y-4">
        <div className="w-14 h-14 rounded-2xl bg-[#C69C4A]/15 grid place-items-center mx-auto"><KeyRound className="w-7 h-7 text-[#C69C4A]" /></div>
        <h1 className="font-serif-display text-2xl">Bienvenue {user?.name || ""}</h1>
        <p className="text-sm text-stone-400">Votre PIN provisoire a été utilisé. {step === 1 ? `Choisissez votre PIN personnel à ${pinLen} chiffres.` : "Confirmez votre nouveau PIN."}</p>
        <p data-testid="set-own-pin-step" className="text-xs uppercase tracking-wider text-[#C69C4A] font-bold">Étape {step}/2</p>
        <PinPad value={value} onChange={setValue} max={pinLen} disabled={busy} dark />
        <button data-testid="set-own-pin-next" onClick={next} disabled={busy || value.length !== pinLen} className="w-full h-12 rounded-full bg-[#C69C4A] text-[#0C1713] font-extrabold disabled:opacity-40">
          {step === 1 ? "Continuer" : (busy ? "…" : "Enregistrer mon PIN")}
        </button>
        <p className="text-[11px] text-stone-500 flex items-center justify-center gap-1"><ShieldCheck className="w-3.5 h-3.5" /> Chiffré, jamais affiché au Manager ni au propriétaire.</p>
      </div>
    </div>
  );
}
